import { createAction } from 'redux-actions';
export const offerHotelsAction = createAction('OFFER_HOTELS');
